/* eslint-disable no-underscore-dangle */
export default class Ping {
	constructor() {
		this._emotion = '';
		this._pingContainer = document.createElement('aside');
		this._pingContainer.setAttribute('class', 'ping__container');
		document.body.appendChild(this._pingContainer);

		window.addEventListener('ping-ping', (e) => {
			e.preventDefault();
			this.setEmotionClass(e.detail?.emotion);
			this.showPing({
				heading: e.detail?.heading,
				message: e.detail?.message,
			});
		});
	}

	showPing({ heading, message }) {
		const ping = document.createElement('div');
		ping.setAttribute('class', `ping ${this._emotion} flex flex--align-center`);
		ping.innerHTML = `
			<div class="ping__emoji"></div>
			<section>
				<h6 class="text--s">
					${heading}
				</h6>
				<p class="no-margin--bottom text--s text--short text--medium">
					${message}
				</p>
			</section>
		</div>`;
		// add to container
		this._pingContainer.appendChild(ping);
		// hide after 7 seconds
		setTimeout(() => this.hidePing(ping), 7000);
	}

	// eslint-disable-next-line class-methods-use-this
	hidePing(ping) {
		ping.remove();
	}

	setEmotionClass(emotion) {
		switch (emotion) {
			case 'happy':
				this._emotion = 'ping--happy';
				break;
			case 'sad':
				this._emotion = 'ping--sad';
				break;
			case 'meh':
				this._emotion = 'ping--meh';
				break;
			case 'wink':
				this._emotion = 'ping--wink';
				break;
			case 'clap':
				this._emotion = 'ping--clap';
				break;
			default:
				this._emotion = 'ping--idk';
				break;
		}
	}

	static createHappyPing(heading, message) {
		const pingHeading = heading || 'Noted!';
		const pingMessage = message || 'We have successfully saved your change.';
		this.createPing(pingHeading, pingMessage, 'happy');
	}

	static createMehPing(heading, message) {
		const pingHeading = heading || 'Sorry, something went wrong.';
		const pingMessage =
			message || 'Something went wrong with saving your change. Please try again or contact us.';
		this.createPing(pingHeading, pingMessage, 'meh');
	}

	static createWinkPing(heading, message) {
		const pingHeading = heading || 'Oops, that didn’t work.';
		const pingMessage = message || 'That didn’t work. It seems that something is pending';
		this.createPing(pingHeading, pingMessage, 'wink');
	}

	static createSadPing(heading, message) {
		const pingHeading = heading || 'Oops, something went wrong.';
		const pingMessage =
			message ||
			'Sorry, something seems to have gone wrong with the save. Please try again or contact us.';
		this.createPing(pingHeading, pingMessage, 'sad');
	}

	static createPing(heading, message, emotion) {
		window.dispatchEvent(
			new CustomEvent('ping-ping', {
				detail: {
					heading,
					message,
					emotion,
				},
			})
		);
	}
}
